// extracted by mini-css-extract-plugin
export default {"innerWrapper":"nH-z","tooltipWrapper":"oH-z","icon":"pH-z","tooltip":"qH-z","content":"rH-z"};